import React from 'react';
import { PDFIcon } from '../../../../components/Icon/Icon';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>The JD Foundation takes its mission very seriously and
        wants to make a tangible difference to the lives of the children and families which they
        have committed to help. We are here to change lives, not just to talk about it.
        <br />
        <br />
        To find out more about The JD Foundation’s impact on society and communities, please read
        the “Social Impact Report” below:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/jd-foundation-social-impact-report.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="foundation/social-impact.png" />
                    Social Impact Report
                </a>
            </li>
        </ul>
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/jd-foundation-social-impact-report.jpg',
    body: Body,
};
